import { useQuery } from "@tanstack/react-query"
import { useEndpointProvider } from "../Providers/EndpointProvider"

// Field mapping for sorting - maps frontend field names to backend field names
const SORT_FIELD_MAPPING = {
	'patient_id': 'patient_identifier',
	// Add more mappings as needed
}

// Function to transform sort model fields to backend field names
const transformSortModel = (sortModel) => {
	if (!sortModel || !Array.isArray(sortModel)) {
		return sortModel
	}
	
	return sortModel.map(sortItem => ({
		...sortItem,
		field: SORT_FIELD_MAPPING[sortItem.field] || sortItem.field
	}))
}

export const useFetchTableData = props => {
	const endpointProvider = useEndpointProvider()
	const { queryKey, endpoint, body, optionalParams, queryOptions, paginationModel, sortModel, supportsPageSize = false } = props

	// Transform the sort model to use backend field names
	const transformedSortModel = transformSortModel(sortModel)

	const queryKeyObject = {
		...body,
		...optionalParams,
		page: paginationModel.pageIndex,
		...(supportsPageSize && { page_size: paginationModel.pageSize }),
		filters: queryOptions,
		sort: transformedSortModel,
	}

	// Extract signal from React Query context for automatic request cancellation
	const getFn = async ({ signal }) => {
		return endpointProvider.post(endpoint, queryKeyObject, optionalParams, signal)
	}

	return useQuery({
		queryKey: [queryKey, { ...queryKeyObject }],
		queryFn: getFn, // React Query passes { signal } to this function
		keepPreviousData: true,
		// Loose equality catches BOTH null and undefined. The previous
		// `endpoint !== undefined` let `null` through, which then crashed
		// inside endpointProvider.post when callers (ModernMUITable in
		// client-side mode) intentionally pass `endpoint: null` to mean
		// "no server fetch needed."
		enabled: endpoint != null
	})
}
